import { render, staticRenderFns } from "./Coaches.vue?vue&type=template&id=cb7d98ac&scoped=true"
import script from "./Coaches.vue?vue&type=script&lang=js"
export * from "./Coaches.vue?vue&type=script&lang=js"
import style0 from "./Coaches.vue?vue&type=style&index=0&id=cb7d98ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7d98ac",
  null
  
)

export default component.exports